import { Injectable, Injector, inject } from '@angular/core';
import {
  TranslocoMissingHandler,
  TranslocoMissingHandlerData,
  TranslocoService
} from '@jsverse/transloco';
import { isUndefined } from 'lodash-es';

@Injectable()
export class MyCustomMissingTranslationHandler implements TranslocoMissingHandler {
  // Injector used to break circular dependency: TranslocoService → TRANSLOCO_MISSING_HANDLER → handler → TranslocoService
  private injector = inject(Injector);

  handle(key: string, _data: TranslocoMissingHandlerData, params?: Record<string, any>): string {
    if (params) {
      if (!isUndefined(params['default'])) {
        return this.injector.get(TranslocoService).translate(params['default'], params);
      } else if (!isUndefined(params['defaultValue'])) {
        return params['defaultValue'];
      }
    }
    return `[${key}]`;
  }
}
